module.exports = __webpack_public_path__ + "img/specialty-icon.3d0fc6ee.png";